import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from "vue";
import { Effect, PaginationType } from "@/types";
import SwiperCore, { EffectCoverflow, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.scss";
import { ICampaignImage } from "@/domain/entities/serviceInfo/serviceInfo.types";
import InlineSvg from "vue-inline-svg";
import ZoomControl from "../shared/ZoomControl.vue";


const __default__ = {
  name: "CampaignDetailSwiper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  campaignImages: {
    type: Array as PropType<ICampaignImage[]>,
    required: true,
  },
  campaignTitle: {
    type: String,
    required: true,
  },
  altText: {
    type: String,
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

SwiperCore.use([EffectCoverflow, Navigation, Pagination]);

const props = __props;

const emit = __emit;

const zoomControl = ref<InstanceType<typeof ZoomControl>>();

const cardNewsImageAltText = computed(
  () => props.altText ?? `${props.campaignTitle} 관련된 카드뉴스 이미지입니다.`
);

const swiperOptions = {
  class: "card-swiper",
  modules: [EffectCoverflow],
  effect: "coverflow" as Effect,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 120,
    modifier: 1,
    slideShadows: false,
  },
  centeredSlides: true,
  loop: false,
  pagination: {
    el: ".pagination_bullet",
    type: "fraction" as PaginationType,
  },
  paginationClickable: true,
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  observer: true, // 슬라이드가 동적으로 추가되거나 제거될 때 Swiper 인스턴스 업데이트 여부
};

const swiperInstance = ref();
const onSwiper = async (swiper: SwiperCore) => {
  swiperInstance.value = swiper;
};

const swiperRealIndex = ref(0);
const onSlideChange = (swiper: SwiperCore) => {
  zoomControl.value?.resetZoom();
  swiperRealIndex.value = swiper.realIndex;
  if (swiperInstance.value) {
    swiperInstance.value.allowTouchMove = true;
  }
};

const onUpdatedZoom = (isZoomedIn: boolean) => {
  if (!swiperInstance.value) return;

  swiperInstance.value.allowTouchMove = !isZoomedIn;
};

const emitOnClickCloseBtn = () => {
  emit("onClickCloseBtn");
};

const __returned__ = { props, emit, zoomControl, cardNewsImageAltText, swiperOptions, swiperInstance, onSwiper, swiperRealIndex, onSlideChange, onUpdatedZoom, emitOnClickCloseBtn, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide }, get InlineSvg() { return InlineSvg }, ZoomControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})